import './SearchableTimelineList.scss';
import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import { PeriscopeV3PaginatedList } from '../PeriscopeV3PaginatedList';
import { TimelineRecord } from './TimelineRecord';
import { timelineSortOptions } from './TimelineSortOptions';
import { trigger } from '@lib/events';
import { Button, Row } from 'antd';
import { keyPaginationDefaultQueryParams, keyPaginationFallbackQueryParams } from '@ui/KeyPagination';
import { useQueryResource } from '@hooks';
import React, { useCallback } from 'react';
import { TimelineSearch } from './TimelineSearch';
export const SearchableTimelineList = ({ sonarObjectId }) => {
    const { loading, resource, queryParams, updateParams } = useQueryResource({
        defaultParams: Object.assign(Object.assign({}, keyPaginationDefaultQueryParams), { sortBy: timelineSortOptions[0].key, sortDirection: timelineSortOptions[0].direction }),
        fallbackParams: keyPaginationFallbackQueryParams,
        uri: `v3/core/sonar-objects/${sonarObjectId}/timelines`
    });
    const handleExpandAll = useCallback(() => {
        trigger(`periscope-timeline-${sonarObjectId}:expandAll`);
    }, [sonarObjectId]);
    const handleCollapseAll = useCallback(() => {
        trigger(`periscope-timeline-${sonarObjectId}:collapseAll`);
    }, [sonarObjectId]);
    return (React.createElement(React.Fragment, null,
        React.createElement(TimelineSearch, { onChange: updateParams, queryParams: queryParams, sonarObjectId: sonarObjectId }),
        React.createElement(Row, { className: 'expand-collapse-row' },
            React.createElement(Button, { className: 'expand-all-button', onClick: handleExpandAll, size: 'small', type: 'link' }, COPY_GENERIC.EXPAND_ALL),
            React.createElement(Button, { className: 'collapse-all-button', onClick: handleCollapseAll, size: 'small', type: 'link' }, COPY_GENERIC.COLLAPSE_ALL)),
        React.createElement(PeriscopeV3PaginatedList, { loading: loading, onChange: updateParams, queryParams: queryParams, renderListItem: (item) => React.createElement(TimelineRecord, { key: item.change.id, parentSonarObjectId: sonarObjectId, record: item }), resource: resource })));
};
